
(function(){
  var el=document.getElementById("ssNavLoading");
  if(!el)return;
  var hideTimer=null,showTimer=null;
  var frames=el.querySelectorAll("[data-nav-loading-frames] img");
  var frameTimer=null,frameIndex=0;
  var reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function setFrame(index){
    if(!frames.length)return;
    for(var i=0;i<frames.length;i++)frames[i].classList.toggle("is-active",i===index);
  }
  function startFrames(){
    if(!frames.length||reduced||frameTimer)return;
    frameTimer=setInterval(function(){frameIndex=(frameIndex+1)%frames.length;setFrame(frameIndex)},125);
  }
  function stopFrames(){
    if(frameTimer){clearInterval(frameTimer);frameTimer=null}
    frameIndex=0;setFrame(frameIndex);
  }
  function syncAria(on){
    el.setAttribute("aria-busy",on?"true":"false");
    el.setAttribute("aria-hidden",on?"false":"true");
  }
  function reveal(){
    showTimer=null;
    el.classList.add("open");
    syncAria(true);
    startFrames();
  }
  function show(){
    if(hideTimer)clearTimeout(hideTimer);
    if(!showTimer&&!el.classList.contains("open"))showTimer=setTimeout(reveal,120);
    // A navigation that never leaves (a download, a cancelled unload) must not strand it.
    hideTimer=setTimeout(hide,12000);
  }
  // A click that should leave and doesn't. Kosuke, 2026-10-17: the viewer's sheep
  // (its Back) flew until the 12 s timeout, the click never reached the worker, and a
  // reload didn't help. That Back stepped history.back(), which can step only the
  // space's frame and leave the page where it is; a click on a link Chrome is
  // prerendering (the header's places, assets/shell/nav-prerender.ts) waits on that
  // prerender, which can stall too. So a click still here after NAV_STALL_MS drops
  // the page's speculation rules (cancelling their prerenders) and goes to the link's
  // own address, once. Only for the prerendered paths and links marked
  // data-nav-retry: anywhere else a page that stays put may be a download, and a
  // second press would fetch it twice. Every stall is counted ("Nav Stalled").
  var stallTimer=null,PRERENDERED=["/","/sessions","/messages"];
  function stalled(href,path,marked,t0){
    stallTimer=null;
    var retry=marked||PRERENDERED.indexOf(path)>=0;
    if(window.mixpanel)mixpanel.track("Nav Stalled",{to:PRERENDERED.indexOf(path)>=0?path:"other",back:marked,retried:retry,ms:Date.now()-t0},{transport:"sendBeacon"});
    if(!retry)return;
    var rules=document.querySelectorAll('script[type="speculationrules"]');
    for(var i=0;i<rules.length;i++)rules[i].remove();
    location.assign(href);
  }
  function hide(){
    if(stallTimer){clearTimeout(stallTimer);stallTimer=null}
    if(showTimer){clearTimeout(showTimer);showTimer=null}
    if(hideTimer){clearTimeout(hideTimer);hideTimer=null}
    el.classList.remove("open");
    syncAria(false);
    stopFrames();
  }
  window.ssNavLoading={show:show,hide:hide};
  window.addEventListener("pageshow",function(e){if(e.persisted)hide()});
  window.addEventListener("pagehide",function(){if(stallTimer){clearTimeout(stallTimer);stallTimer=null}});
  document.addEventListener("click",function(e){
    if(e.defaultPrevented||e.button!==0)return;
    if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    var a=e.target&&e.target.closest?e.target.closest("a[href]"):null;
    if(!a||a.target==="_blank"||a.hasAttribute("download"))return;
    // A link the page handles itself (a sort header, a search box's ×) never
    // navigates, so the veil it raised here would hang until the 12s timeout. This
    // listener runs in the CAPTURE phase, before the page's own handler has had a
    // chance to preventDefault, so the link has to say so up front.
    if(a.hasAttribute("data-nav-inline"))return;
    // A space card: its viewer page was prefetched on the press (spaceCardWarmup), and
    // the page itself grows out of the card while it loads (assets/shell/space-open.ts).
    if(a.hasAttribute("data-nav-quiet"))return;
    var raw=a.getAttribute("href");
    if(!raw||raw.charAt(0)==="#"||raw.indexOf("javascript:")===0||raw.indexOf("mailto:")===0)return;
    var url;try{url=new URL(a.href,location.href)}catch(err){return}
    if(url.origin!==location.origin)return;
    if(url.pathname===location.pathname&&url.search===location.search)return;
    show();
    if(stallTimer)clearTimeout(stallTimer);
    var t0=Date.now(),path=url.search?"":url.pathname,marked=a.hasAttribute("data-nav-retry");
    stallTimer=setTimeout(function(){stalled(url.href,path,marked,t0)},4000);
  },true);
})();
